import Cookies from 'js-cookie';

import { useFlagsStore } from '@/lib/client-store';

export const DEBUG_COOKIE_NAME = 'surface-ui-debug';
export const VERSION_COOKIE_NAME = 'surface-ui-version';

export const getDebugFromCookie = (): boolean => {
  return Cookies.get(DEBUG_COOKIE_NAME) === 'true';
};

export const setDebugCookie = (enabled: boolean): void => {
  Cookies.set(DEBUG_COOKIE_NAME, enabled.toString(), {
    path: '/',
    expires: 365, // 1 year
  });
};

export const useDebugFlag = (): boolean => useFlagsStore((s) => s.debug);

export const useSetDebugFlag = () => {
  return (enabled: boolean) => useFlagsStore.setState({ debug: enabled });
};
